import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function AdvisoryBoardPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white font-body text-ink">
      <Header />

      <section className="flex flex-1 items-center px-6 py-32 md:px-12">
        <div className="mx-auto max-w-3xl text-center">
          <div className="text-xs uppercase tracking-[0.22em] text-calblue">
            Advisory Board
          </div>
          <h1 className="mt-6 font-serif text-5xl font-medium leading-[1.05] tracking-tight text-ink md:text-7xl">
            Coming Soon
          </h1>
          <p className="mx-auto mt-8 max-w-xl text-lg leading-relaxed text-slate-700">
            We are assembling an advisory board of deliberately different viewpoints —
            renters, housing providers, attorneys, researchers, and economists. When people
            who often disagree are willing to advise the same project, it signals our intent
            clearly: we exist to understand and improve the system, not to represent one side
            of it.
          </p>
          <a
            data-testid="advisory-contact-button"
            href="mailto:ray@proptekinc.com?subject=California Rental Experience Project — Advisory Board"
            className="mt-10 inline-flex items-center border border-navy px-8 py-3 text-sm font-medium text-navy transition-colors hover:bg-navy hover:text-white"
          >
            Express interest
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
